<template>
  <div class="container-fluid">
    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">

    </vk-offcanvas>
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div class="page-content__header-description" style="display: flex; margin-bottom: 20px;">
        <h2 style="flex: 1;">User </h2>
        <div v-if ="usertype != 'customer admin'" style="display: flex; margin-right: 20px;">
          <span style="flex: 1; align-items: center;">
            <router-link class="btn btn-primary" to="/user/new">New User</router-link>
          </span>
        </div>
      
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <can I="read" a="user">
              <Users />
            </can>
       
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Users from "../users/index";
import Devices from "../devices/List";
import transactionHistories from "../shs/Wallet";
import userRole from "../users/allow";
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
  // ...
} from "element-ui";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";

export default {
  name: "",
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton,
    Users,
    Devices,
    transactionHistories,
    userRole
  },
  data() {
    return {
      showOffCanvas: false,
      activeTab: "user_list",
      usertype: localStorage.roleType
    };
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/user-mgt/Users.vue